module.exports = [{"id":1,"name":"GTX Printer","localeName":"gtxprinter","prices":[{"id":1,"price":19995},{"id":3,"price":22695}]},{"id":2,"name":"Transferpresse","localeName":"transferpresse","prices":[{"id":1,"price":1290},{"id":3,"price":1548}]},{"id":3,"name":"Pretreatmaker","localeName":"pretreatmaker","prices":[{"id":1,"price":4339},{"id":3,"price":5206.8}]},{"id":4,"name":"Pretreatmaker LINE","localeName":"pretreatmakerLine","prices":[{"id":1,"price":75000},{"id":3,"price":90000}]},{"id":5,"name":"Tunneltrockner","localeName":"tunneltrockner","prices":[{"id":1,"price":15300},{"id":3,"price":18360}]}]


//////////////////
// WEBPACK FOOTER
// ./src/data/devices.json
// module id = 71
// module chunks = 0